module.exports = __webpack_public_path__ + "static/media/flag.99c95e54.svg";